import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DataResService, DesActivarConcesionGQL, ActivarConcesionGQL } from '@app/services/data.services';
import { EmbarcacionConcesion } from '@app/types/types';
import { Subscription } from 'rxjs';
import gql from 'graphql-tag';
import { Apollo } from 'apollo-angular';
import { NotificationService } from '@app/services/notification.service';
import { delay, tap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-embarcacion-concesion-list',
  templateUrl: './embarcacion-concesion-list.component.html',
  styleUrls: ['./embarcacion-concesion-list.component.css']
})
export class EmbarcacionConcesionListComponent implements OnInit, OnDestroy {

  // variables generales
  texto = '';
  total = 0;
  pageSize = 0;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  loading = false;
  nicConcesion = new FormControl();
  nitConcesion = new FormControl();;
  
   listaDeConcesiones$: any[] = [];
  private querySubscription: Subscription;
  GQL: any;
  @ViewChild('content') content: ElementRef;

  
 
  constructor( private apollo: Apollo,
  private activarConcesionGQL: ActivarConcesionGQL,
  private desActivarConcesionGQL: DesActivarConcesionGQL,
  private notificationService: NotificationService,) { }
  
  ngOnInit(): void {
    this.initForm();
    this.traerListaConcesiones();
  }

  initForm() {
    this.nicConcesion.setValue("");
    this.nitConcesion.setValue("");
  }
  loadQuery() {
    this.GQL = gql`
    query listaDeConcesiones { 
      listaDeConcesiones (
        keyword:"${this.nicConcesion.value}"
        ){
     
      raResoluembs{
        embarcacionNic
            reEmbarcaci{
            nombre
      }
        personaDocumento
        rembFechaIni
        rembFechaFin
        rembUsuaregistraAudi
  
      }
      total
    }
  }
  `;
  }

  traerListaConcesiones(pageEvent: PageEvent = null) {
    this.loadQuery();
    this.loading = true;
    if (pageEvent) {
      this.pageIndex = pageEvent.pageIndex;
      this.pageSize = pageEvent.pageSize;
    }

    this.loadQuery();
    console.log('trayendo concesiones');
    this.querySubscription = this.apollo.watchQuery<any>({
      query: this.GQL,
    })
      .valueChanges.pipe(
        tap(() => console.log('Wait 5 seconds')),
        delay(500),
    ).subscribe(({ data, loading }) => {
      this.listaDeConcesiones$ = data.listaDeConcesiones.raResoluembs;
      this.total =  data.listaDeConcesiones.total;
      this.loading = false;
      console.log('Concesiones traídas');
    },
      (error) => {
        console.log(error);
        this.notificationService.showNotification('Datos invalidos', 'Datos invalidos', 'warning');
      });
    }



    applyFilter(event: Event) {
      this.texto = (event.target as HTMLInputElement).value;
      this.traerListaConcesiones();
    }
    
    activarConcesion() {
      this.activarConcesionGQL
      .mutate({
          parametroNic: this.nicConcesion.value,
          concesionNit: this.nitConcesion.value
      })
      .subscribe(({ data }: any) => {
        this.loading = false;
        console.log(data.activarConcesion);
        if(data.activarConcesion.status){
          this.notificationService.showNotification('Muy bien!', data.activarConcesion, 'success');
          
        } else {
          this.notificationService.showNotification('No cumple con requerimientos',  data.activarConcesion, 'warning')
        }
        this.traerListaConcesiones();
        // location.href = '#/zarpes';
      },
        (error) => {
          this.loading = false;
          console.log(error);
          this.notificationService.showNotification('No cumple con requerimientos', 'Revisar parámetros', 'warning');
        }
      )
      
    }
    // Función que cancela el zarpe
    desActivarConcesion() {
      this.desActivarConcesionGQL
      .mutate({
          parametroNic: this.nicConcesion.value,
          concesionNit: this.nitConcesion.value
      })
      .subscribe(({ data }: any) => {
        this.loading = false;
        console.log(data.desactivarConcesion);
        if(data.desactivarConcesion.status){
          this.notificationService.showNotification('Muy bien!', data.desactivarConcesion, 'success');
          
        } else {
          this.notificationService.showNotification('No cumple con requerimientos',  data.desactivarConcesion, 'warning')
        }
        this.traerListaConcesiones();
        // location.href = '#/zarpes';
      },
        (error) => {
          this.loading = false;
          console.log(error);
          this.notificationService.showNotification('No cumple con requerimientos', 'Revisar parámetros', 'warning');
        }
      )

     

    }

    public ngOnDestroy() {
      console.log('destroying');
      this.querySubscription.unsubscribe();
    }
    
}



